export default {
	CITY: {
		i18n: 'town',
		color: '56,61,128',
		type: 'CITY'
	},
	WATERSHED: {
		i18n: 'watershed',
		color: '22,24,50',
		type: 'WATERSHED'
	},
	STATION: {
		i18n: 'station',
		color: '84,91,191',
		type: 'STATION'
	},
	DEPARTMENT: {
		i18n: 'department',
		color: '56,61,128',
		type: 'DEPARTMENT'
	},
	RADIUS: {
		i18n: 'radius',
		color: '22,24,50',
		type: 'RADIUS'
	},
	LAYER: {
		i18n: 'layer',
		color: '22,24,50',
		type: 'LAYER'
	},
	THEME: {
		i18n: 'themes',
		color: '22,24,50',
		type: 'THEME'
	},
	MANAGEMENT_WATER: {
		i18n: 'managementWater',
		color: '22,24,50',
		type: 'MANAGEMENT_WATER'
	}
}



// WEBPACK FOOTER //
// ./src/utils/ResearchTypes.js